export default "__VITE_ASSET__DIk7NKgk__"